import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'auth-layout',
    standalone: true,
    imports: [RouterModule, ToastModule],
    providers: [MessageService],
    templateUrl: './app.authlayout.html',
    styleUrl: './app.authlayout.scss'
})
export class AuthLayout {}
